import Service from '../service.js';

export default {
    data() {
        return {
            activities: [

                // {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-12 '

                // }, {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-03 '

                // }, {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-03 '

                // }, {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-03 '
                // },
                // {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-03 '
                // },
                // {
                //     content: '正和****公司 与 中国农业银行对接成功',
                //     timestamp: '2018-04-03 '
                // }
            ],
            tId: '67bec61f46cb25d6d284f5aa'
        };
    },
    created() {
        this.getnews();
    },
    methods: {
        handClick(url) {
            this.$router.push(url);

        },
        getnews() {
            Service.getnews({ catalogId: this.tId, skip: this.skip, limit: this.limit }).then(res => {
                // this.detail = res;
                // this.slides = res.listImages;
                // console.log(res, '111');
                this.activities = res.result;
            });
        },
        getCreatedTimeYear(date) {
            const baseDateFilter = this.$options.filters['baseDate'];
            const baseDate = baseDateFilter(date);
            return baseDate.substring(0, 10);
        },
         // 详情
      toDetailPage(id) {
        this.$router.push({
            path: '/finance-insurance/InformationDetails',
            query: {
                id: id
            }
        });
        // console.log(id, '3231');
    }
    }

};

